import ImageUploader from './ImageUploader'

const Attachments = (props) => {
  let uploader = null
  return (
    <div className={`form-group qa-${props.className}-container`}>
      <label>{props.label}</label>
      {props.meta}
      {
        props.isAttachmentSelected ? (
          <div className='attachments-image-container'>
            <div className={`attachments-image-wrapper ${props.className ? props.className : ''}`}>
              <img src={props.imageSrc} />
              <span class='component-uploader__image-details'>
                {props.width}px &times; {props.height}px <i class='icon icon-external' />
              </span>
            </div>
            <div className='attachments-image_buttons'>
              <button className='btn btn-default btn-edit' type='button' onClick={() => uploader.click()}>Edit</button>
              <button className='btn btn-default btn-delete' type='button' onClick={() => props.onUpdate(null)}>Remove</button>
            </div>
          </div>
        ) : (
          <button className='btn btn-default btn-upload' type='button' onClick={() => uploader.click()}>Upload image</button>
        )
      }
      <ImageUploader
        width={props.width}
        height={props.height}
        onUploaded={(response) => props.onUpdate(response)}
        uploaderRef={(ref) => { uploader = ref }}
      />
    </div>
  )
}

export default Attachments
